import { render, staticRenderFns } from "./UserAccountReport.vue?vue&type=template&id=ca15d492&scoped=true&"
import script from "./UserAccountReport.vue?vue&type=script&lang=js&"
export * from "./UserAccountReport.vue?vue&type=script&lang=js&"
import style0 from "./UserAccountReport.vue?vue&type=style&index=0&id=ca15d492&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca15d492",
  null
  
)

export default component.exports